import { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import { Link as RouterLink } from "react-router-dom";

export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const drawer = (
    <Box
      sx={{
        width: "100%",
        maxWidth: 400,
        mx: "auto",
        bgcolor: "background.paper",
        borderRadius: 2,
        mt: 2,
        boxShadow: theme.shadows[4],
      }}
      role="presentation"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontFamily: "Quicksand, sans-serif", fontWeight: 700 }}
        >
          BONDPAY
        </Typography>
        <IconButton onClick={handleDrawerToggle}>
          <CloseIcon />
        </IconButton>
      </Box>
      <List>
        <ListItem disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/how-it-works"
            onClick={handleDrawerToggle}
          >
            <ListItemText
              primary="How it works"
              primaryTypographyProps={{ fontWeight: 700 }}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/apply"
            onClick={handleDrawerToggle}
          >
            <ListItemText
              primary="Apply Now"
              primaryTypographyProps={{ fontWeight: 700 }}
            />
            <ArrowForwardIcon fontSize="small" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/blog"
            onClick={handleDrawerToggle}
          >
            <ListItemText
              primary="Blog"
              primaryTypographyProps={{ fontWeight: 700 }}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/faq"
            onClick={handleDrawerToggle}
          >
            <ListItemText
              primary="FAQ"
              primaryTypographyProps={{ fontWeight: 700 }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <AppBar position="sticky" color="default" elevation={1} sx={{ py: 2 }}>
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <RouterLink to="/" style={{ textDecoration: "none" }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Quicksand, sans-serif",
              fontWeight: 700,
              color: "black",
            }}
          >
            BONDPAY
          </Typography>
        </RouterLink>

        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            gap: 2,
          }}
        >
          <Link
            to="/how-it-works"
            underline="none"
            color="primary"
            component={RouterLink}
          >
            How it works
          </Link>
          <Button variant="outlined" color="primary">
            <Link
              component={RouterLink}
              to="/blog"
              underline="none"
              color="primary"
            >
              Blog
            </Link>
          </Button>
          <Button variant="outlined" color="primary">
            <Link
              component={RouterLink}
              to="/faq"
              underline="none"
              color="primary"
            >
              FAQ
            </Link>
          </Button>
          <Button
            variant="contained"
            color="primary"
            endIcon={<ArrowForwardIcon />}
            component={RouterLink}
            to="/apply"
          >
            Apply Now
          </Button>
        </Box>

        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="end"
          onClick={handleDrawerToggle}
          sx={{ display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>
      </Container>

      <Drawer
        anchor="top"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { sm: "none" },
          "& .MuiDrawer-paper": {
            borderRadius: 0,
            bgcolor: "transparent",
            boxShadow: "none",
          },
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
}
